import React from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Box } from "@mui/material";

import { TableCell, TableRow } from "ui";

import { Version } from "fond/types";
import { formatCurrency } from "fond/utils/currency";
import { calculateDelta, formatPercent } from "fond/utils/number";

import { CostDeltaChip, VersionNameBadge } from "./ScenarioPanel.styles";

type ScenarioPanelBomComparisonRowProps = {
  baselineVersion: Version;
  currentTotal: number;
  baselineTotal: number;
  currency?: string;
};

export const ScenarioPanelBomComparisonRow: React.FC<ScenarioPanelBomComparisonRowProps> = ({
  baselineVersion,
  currentTotal,
  baselineTotal,
  currency,
}) => {
  const { deltaPercent: costDeltaPercent, isIncrease: isCostIncrease } = calculateDelta(currentTotal, baselineTotal) ?? {
    deltaPercent: 0,
    isIncrease: false,
  };

  return (
    <TableRow>
      <TableCell>
        vs. <VersionNameBadge component="span">{baselineVersion.Name}</VersionNameBadge>
      </TableCell>
      <TableCell align="right">
        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
          <Box component="span" color="text.secondary">
            {formatCurrency(baselineTotal, { currency })}
          </Box>
          <CostDeltaChip
            size="small"
            isIncrease={isCostIncrease}
            icon={isCostIncrease ? <ArrowUpward /> : <ArrowDownward />}
            label={formatPercent(Math.abs(costDeltaPercent), 1)}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};
